import type { AppIconProps } from "../IconTypes";

export const TransferIcon: React.FC<AppIconProps> = ({
  width = 16,
  height = 16,
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="#1D9F81"
      className={className}
    >
      <g>
        <rect fill="none" height="16" width="16" x="0" />
      </g>
      <g>
        <g>
          <polygon points="7.41,13.41 6,12 2,16 6,20 7.41,18.59 5.83,17 21,17 21,15 5.83,15" />
          <polygon points="16.59,10.59 18,12 22,8 18,4 16.59,5.41 18.17,7 3,7 3,9 18.17,9" />
        </g>
      </g>
    </svg>
  );
};
